module.exports = __webpack_public_path__ + "img/feedback.d7f2f046.svg";